import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_4_1_1 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}
      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.1 Case 1</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>

        <ModuleQuestion
          correctAnswer="B"
          assessmentName="challenge_case_1"
          videoTranscript={
            <>
              <p>
                This is challenge case number 1. This is a negative case.
                Beginning at the level of the cerebellum and entering into the
                occipital region, you may notice some initial blurring seen here
                on the left and here on the right. This finding, which can be
                seen in the immediate inferior slices, is likely due to this
                scanner.
              </p>
              <p>
                It is important to review the slices immediately superior and in
                fact, white matter tracts are now identifiable on the left, as
                well as on the right. White matter tracts are easily delineated
                coursing through the temporal and occipital regions on the right
                as well as on the left, and less intense activity is seen in the
                surrounding gray matter bilaterally. There is preserved
                gray-white contrast throughout.
              </p>
              <p>
                As we enter into the frontal cortices seen here, white matter
                finger-like projections are also identified on the right, as
                well as on the left. Less intense activity in the gray matter is
                also seen.
              </p>
              <p>
                Similar to the temporal and occipital regions, there is
                preserved gray-white contrast here. In addition, white matter
                tracts are clearly delineated moving from the front of the brain
                to the back of the brain on the left, as well as on the right.
                In the superior parietal region, white matter tracts are also
                delineated on the left and on the right. In the medial parietal
                region, identified here, increased activity is not seen in the
                gray matter. Therefore, as there is no loss of gray-white
                contrast, this scan is negative. If you called this case
                positive, you may want to review the case once again in the
                MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-0"
          nextLesson="/module-4/module-4-1-2"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_107252026&entry_id=1_p2nqslp7&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_p2nqslp7"
        />
      </main>
    </div>
  );
};

export default Module_4_1_1;
